// extracted by css-extract-rspack-plugin
export default {"root":"m4ZUT8mbm7kptcY8","body":"TtDmcjrQdmQXaTuc","attachments":"Blg5pksE7CoQC25Z","images":"KKOo9tLAJSkEVrg5","image":"Eq2z26oyHhQ4WUMt","text":"skHMuBNqQhw1rN_K"};